import { connect } from 'react-redux';

import Dropdown from './Dropdown';
import {
    trackRefineSearchClickSpecialtiesDropdown,
    trackRefineSearchSelectSpecialty,
} from '../../../../../actions';

const mapDispatchToProps = {
    trackRefineSearchClickSpecialtiesDropdown,
    trackRefineSearchSelectSpecialty,
};

export default connect(undefined, mapDispatchToProps)(Dropdown);
